import React, { useContext, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import 'bootstrap/dist/css/bootstrap.min.css';
import './StockDetails.css'
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer, 
  // Area
  // defs, linearGradient, stop
} from 'recharts';
import axios from 'axios';
import HomeIcon from '@mui/icons-material/Home';
import { StockContext } from '../../Context/StockContext';
// import KeyboardDoubleArrowDownIcon from '@mui/icons-material/KeyboardDoubleArrowDown';
// import KeyboardDoubleArrowUpIcon from '@mui/icons-material/KeyboardDoubleArrowUp';


const StockDetails = () => {

  const { StockGraphList } = useContext(StockContext)

  const location = useLocation();
  const { companyName, StockPrice, componentColor } = location.state || {};

  const [textResponse, setTextResponse] = useState([''])

  const navigate = useNavigate()

  function handleClickHome() {
    navigate('/')
  }

  console.log(componentColor);

  const StockGraphList_Filtered = StockGraphList && StockGraphList.filter((item) => item.company_name === companyName)
  // console.log(StockGraphList_Filtered)

  console.log(StockGraphList)
  console.log(companyName)
  console.log(StockGraphList_Filtered)


  const trend = componentColor === 'red' ? 'fall' : 'raise'
  const question = `Why did the stock price of ${companyName} ${trend} ?`

  const handleGetResponse = async () => {
    try {
      setTextResponse(null)
      // const question = `Why did the stock price of ${companyName} ${trend}` 
      const response = await axios.post("https://nggtd1ser7.execute-api.ap-south-1.amazonaws.com/dev/stock_details/request_GPT", { raiseQuestion: question })
      const answer = response.data.response
      // console.log(answer)
      // const formattedResponse = formatResponse(response.data.GPT_Text)
      // const formattedResponse = formatResponse(response.data.response)
      // console.log(formattedResponse)

      const formattedText = answer.replace(/\*\*(.*?)\*\*/g, '<b>$1</b>');
      console.log('This is a formatted text: ', formattedText)
      setTextResponse(response.data.response)

      console.log('successfully retrieved the data from API')
    } catch (error) { console.error("There was an error getting the response from GPT", error) }
  }

  const formatText = (text) => {
    return String(text)
      // Replace **text** with <b>text</b>
      .replace(/\*\*(.*?)\*\*/g, '<b>$1</b>')

      // Insert <br> before each numbered item (1., 2., 3., ...)
      .replace(/(^|\n|\<br\>)(\d+\.\s)/g, '<br>$1')

  };

  // console.log(textResponse)


  return (
    <div>

      <div className='StockDetails-header m-2'>
        <span className="home-icon-wrapper"><HomeIcon onClick={handleClickHome} style={{'cursor':'pointer'}} /></span>
        <h4>{companyName}</h4>
        <i>StockPrice :   ₹{StockPrice}/-</i>
      </div>
      <div className='StockDetails-ResponsiveContainer m-3'>
      <ResponsiveContainer width="100%" height={400}>
        <LineChart data={StockGraphList_Filtered}>

          <CartesianGrid strokeDasharray='3 3' />
          <XAxis dataKey="date" />
          <YAxis dataKey="price" domain={['auto', 'auto']} />
          <Tooltip />
          <Legend />

          <Line type='monotone' dataKey='price' stroke={componentColor === 'red' ? "#FF0000" : "#008000"} />

        </LineChart>
      </ResponsiveContainer>
      </div>
      <button onClick={() => handleGetResponse(companyName)}>Get Reason</button>
      <div className='border m-2 p-2 rounded'>
        <p>{question}</p>
        <div>
          {textResponse === null || textResponse === '' ? (<div className="spinner-border text-primary" role="status"></div>) :
            <p dangerouslySetInnerHTML={{ __html: formatText(textResponse) }} />}
        </div>
      </div>
    </div>
  )
}

export default StockDetails